import { render, staticRenderFns } from "./DxPlanningComponent.vue?vue&type=template&id=971168aa&scoped=true&"
import script from "./DxPlanningComponent.vue?vue&type=script&lang=js&"
export * from "./DxPlanningComponent.vue?vue&type=script&lang=js&"
import style0 from "./DxPlanningComponent.vue?vue&type=style&index=0&id=971168aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971168aa",
  null
  
)

export default component.exports